import axios from 'axios';
import React, { useState } from 'react'
import { useNavigate, Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import styles from '../../Business.css';
import banner from '../../images/banners/client.jpg'
import BACKEND_URL from '../../api';

export default function Client_zone() {

    const INTEGRA_URL = process.env.REACT_APP_INTEGRA_URL;
    const navigate = useNavigate();
    const [parcels, setparcels] = useState()
    const [sendpath, setsendpath] = useState()
    const [loggeduser, setloggeduser] = useState({
        username: "",
        password: ""
    })

    function clientzone_login() {
        // window.location.assign('http://timeexpress.dnsalias.com:880/onlinebooking/Index.aspx', '_blank')
        window.open('http://timeexpress.dnsalias.com:880/onlinebooking/Index.aspx', '_blank');
    }

    function dashboardLogin() {
        if (loggeduser.username != "" && loggeduser.password != "") {

            fetch(`${BACKEND_URL}/dashboardLogin`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json', // Set the content type
                },
                body: JSON.stringify(loggeduser) // Convert the loggeduser object to a JSON string
            })
                .then((response) => {
                    if (!response.ok) {
                        throw new Error('Network response was not ok ' + response.statusText);
                    }
                    return response.json(); // Parse the JSON from the response
                })
                .then((data) => {
                    console.log("---------", data);
                    if (data.result > 0) {
                        console.log('dashboard' + data.result);
                        sessionStorage.setItem('accountno', data.result);
                        navigate('/dashboard'); // Navigate to the dashboard
                    } else {
                        alert("Password mismatch");
                    }
                })
                .catch((error) => console.log('Fetch error: ', error));
        } else {
            console.log("Enter username and password")
        }

    }

    return (
        <div className="clientzone">

            <Helmet>
                <title>Shypv | Client Zone</title>
            </Helmet>
            <section className="your_business_page fw" style={{ backgroundImage: `url(${banner})`, backgroundAttachment: 'fixed', backgroundSize: 'cover' }}>
                <div className="container">
                    <div className="row">
                        <div className="col-md-12 col-sm-12 your_business text-center client_zone">
                            <div className="business_content">

                                <h1 className='h1-title'>CLIENT ZONE</h1></div>
                            <div className="container">
                                <div className="row">



                                    <div className="col-md-5" style={{ border: "1px solid", marginTop: "6%", marginBottom: "6%", background: "#fff" }}>

                                        <div id="primary" className="content-area" style={{ float: 'left', padding: '3%', width: "100%" }}>
                                            <h3 style={{ textTransform: "uppercase", padding: "3%" }}><span>Sign in to your account</span></h3>
                                            {/* <main id="main" className="site-main" role="main">
                                                <form >
                                                    <input type="text" name="userid" onChange={(e) => setloggeduser({ ...loggeduser, username: e.target.value })} placeholder="Username" id="username" className="form-control mb-3" required  />
                                                    <input type="text" name="password" onChange={(e) => setloggeduser({ ...loggeduser, password: e.target.value })} placeholder="Password" id="password"  className="form-control  mb-3" required  />
                                                    <button onClick={clientzone_login} type="button" className="btn  btn-sm" style={{ backgroundColor: '#4e25b8', color: "#fff", padding: "2%", width: "19%" }}>Login</button>
                                                </form>
                                            </main> */}
                                            <button onClick={clientzone_login} type="button" className="btn  btn-sm" style={{ backgroundColor: '#4e25b8', color: "#fff", padding: "2%", width: "19%" }}>Login</button>

                                        </div>
                                    </div>
                                    <div className="col-md-1"></div>
                                    <div className="col-md-5" style={{ border: "1px solid", marginTop: "6%", marginBottom: "6%", background: "#fff" }}>
                                        <div id="primary" className="content-area" style={{ float: 'left', padding: '3%', width: "100%" }}>
                                            <h3 style={{ textTransform: "uppercase", padding: "3%" }}><span>CUSTOMER DASHBOARD</span></h3>
                                            {sessionStorage.getItem('accountno') ? (
                                                <p>Please <Link to="/dashboard">click</Link> here to view the dashboard</p>
                                            ) :
                                                (<main id="main" className="site-main" role="main">
                                                    <form>
                                                        <input type="text" placeholder='username' className="form-control mb-3" required onChange={(e) => setloggeduser({ ...loggeduser, username: e.target.value })} />
                                                        <input type="text" placeholder='password' className="form-control  mb-3" required onChange={(e) => setloggeduser({ ...loggeduser, password: e.target.value })} />
                                                        <button type="button" onClick={dashboardLogin} className="btn  btn-sm" style={{ backgroundColor: '#4e25b8', color: "#fff", padding: "2%", width: "19%" }}>Login</button>
                                                    </form>
                                                </main>)
                                            }

                                        </div>
                                    </div>

                                </div>
                            </div>





                        </div>
                    </div>
                </div>


            </section>

        </div>
    )
}
